import { ErrorMessage } from '../ErrorMessage';
import i18n from 'components/i18n';

const getMessage: Record<ErrorMessage, (payload?: any) => string> = {
    requestErrorUnspecified: () => i18n.t('general.Something went wrong'),
    conflict: () => i18n.t('general.Action is not allowed'),
    couldNotSaveResult: () => i18n.t('general.Your result could not be saved'),
    couldNotProcessAssignment: () => i18n.t('general.Your assignment could not be processed'),
    selectedFileTooBig: (payload) => i18n.t(`general.Maximum allowed file size is ${(payload.maxSize / 1024 / 1024).toFixed(0)}Mb`),
    selectedFilesTooBig: (payload) => i18n.t('general.Some of the selected files are too big. ')
        + getMessage[ErrorMessage.selectedFileTooBig](payload),
    selectedFileFormatUnacceptable: () => i18n.t('general.Selected file format is unacceptable'),
    selectedFilesFormatUnacceptable: () => i18n.t('general.Some of the selected files are of an unacceptable format'),
    selectedFilesMultipleProblems: () => i18n.t('general.There are multiple problems with selected files'),
    attachmentLimitReached: (payload) => i18n.t(`general.Maximum number of attachments is ${payload.maxCount}`),
    fileUploadError: () => i18n.t(`general.An error has happened during file upload. Please try again`),
    fileFetchError: () => i18n.t(`general.Could not fetch for attachments`),
    selectedHotelHasNoAssessment: () => i18n.t(`general.Hotel has no assessment`),
};

export function translateErrorMessage (type: ErrorMessage, payload?: any) {
    return getMessage[type](payload);
}
